var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import env from '../core/env';
import { pureAxios } from './core';
/**
 * 参数处理，拼接通用参数
 * @param url
 * @param params
 */
function sendMetrics(url, params) {
    var appName = env.bType;
    var appVersion = env.appVersion;
    var basicParam = {
        view_type: 'h5',
        app_name: appName,
        app_version: appVersion,
        platform: env.isAndroid ? 'android' : 'ios'
    };
    pureAxios.get(url, {
        params: __assign({}, basicParam, params)
    });
}
/* eslint-disable complexity */
/**
 * 发送metrics请求
 * @param response
 * @param afterTime
 * @param type
 */
export function getRequestMetricsParam(response, afterTime, type) {
    var beforeTime = response.config && response.config.beforeTime;
    var url = response.config &&
        response.config.url &&
        response.config.url.split('?')[0];
    var st = response.data && response.data.st;
    var httpSt = response.status || (response.response && response.response.status);
    var reqTime = afterTime - beforeTime;
    var connectType = type || (response.config && response.config.connectType) || 'h5_req';
    var metrics = response && response.config && response.config.metrics;
    var metricsUrl = (metrics && metrics.url) ||
        'https://femetrics.jinritemai.com/metrics/report';
    var customParams = {};
    if (metrics) {
        if (typeof metrics.params === 'function') {
            customParams = metrics.params();
        }
        else if (typeof metrics.params === 'object') {
            customParams = metrics.params;
        }
    }
    var params = __assign({ connect_type: connectType, duration: reqTime, is_timeout: reqTime > 1000 ? 1 : -1, url: url, http_code: httpSt || -1, business_code: Number(st) === 0 || st ? st : '' }, customParams);
    sendMetrics(metricsUrl, params);
}
